import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class Q2AngularcmsService {

  create(env: any, url: any, servicePath: string, modelParams: object) {
    const formData = new FormData();
    formData.append('row', JSON.stringify(modelParams));
    if (env.toLowerCase() === 'dev') {
      return this.httpClient.post(url + '/v2/' + servicePath + '/data/add?verbose=true', formData, {withCredentials: true, responseType: 'text'});
    } else {
      return this.httpClient.post(url + '/v2/' + servicePath + '/data/add', formData, {withCredentials: true, responseType: 'text'});
    }
  }

  read(env: any, url: any, servicePath: string, modelParams?: object) {
    let params = '';
    Object.keys(modelParams).forEach((param, index) => {
        if (modelParams[param] instanceof Array) {
          params += `${param}=`;
          // tslint:disable-next-line:no-shadowed-variable
          modelParams[param].forEach((element, index) => {
            if (index + 1 === modelParams[param].length) {
              params += `${element}`;
            } else {
              params += `${element}&&${param}=`;
            }
          });
          if (index !== Object.keys(modelParams).length) {
            params += `&&`;
          }
        } else {
          if (index === Object.keys(modelParams).length) {
            params += `${param}=${modelParams[param]}`;
          } else {
            params += `${param}=${modelParams[param]}&&`;
          }
        }
    });
    if (!Object.keys(modelParams).includes('maxrows')) {
            params += `&&maxrows=-1`;
          }
    if (env && url.toLowerCase() === 'dev') {
            params += `&&verbose=true`;
          }
    return this.httpClient.get(url + '/v2/' + servicePath + '/data?' + params, {withCredentials: true});
  }

  update(env: any, url: any, servicePath: string, modelParams: object) {
    const formData = new FormData();
    formData.append('row', JSON.stringify(modelParams));
    return this.httpClient.post(url + '/v2/' + servicePath + '/data/edit' +
    (env.toLowerCase() === 'dev' ? '?verbose=true' : ''),
    formData, {withCredentials: true, responseType: 'text'});
  }

  batch(env: any, url: any, servicePath: string, data: [{operation: 'delete' | 'create' | 'update', rows: any}]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(data));
    return this.httpClient.post(url + '/v2/' + servicePath + '/data/import' + (env.toLowerCase() === 'dev' ? '?verbose=true' : ''), formData, {withCredentials: true});
  }

  metaData(url: any, servicePath) {
    return this.httpClient.get(url + '/v2/' + servicePath + '/query/fields?showall=true', {withCredentials: true});
  }

  constructor(private httpClient: HttpClient) { }
}